import { CheckoutBillingAddressEffects } from './checkout-billing-address.effect';
import { CheckoutIncotermEffects } from './incoterm.effect';
import { CheckoutCartsEffects } from './checkout-carts.effect';
import { CheckoutCountriesEffects } from './countries.effect';
import { CheckoutShippingAddressEffects } from './shipping-address.effect';
import { CheckoutShippingMethodEffects } from './shipping-method.effect';
import { CheckoutSubmitOrderEffects } from './checkout-submit-order.effect';

export const effects: any[] = [
    CheckoutBillingAddressEffects,
    CheckoutIncotermEffects,
    CheckoutCartsEffects,
    CheckoutCountriesEffects,
    CheckoutShippingAddressEffects,
    CheckoutShippingMethodEffects,
    CheckoutSubmitOrderEffects,
];

export * from './incoterm.effect';
export * from './checkout-carts.effect';
export * from './countries.effect';
export * from './shipping-address.effect';
export * from './shipping-method.effect';
export * from './checkout-submit-order.effect';